module.exports = __webpack_public_path__ + "static/media/chess-clock-alt.65201993.svg";